import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useMemo } from 'react';
import groupBy from 'lodash/groupBy';
import { useDataActions } from '../hooks/useDataActions';
import DataPathContext from './DataPathContext';
import { IncaContext } from './ScopedIncaContext/IncaContext';
export const IncaRowContext = (props)=>{
    const { path, tableName, rowId } = props;
    const { path: curPath, detachedId: curDetachedId } = useContext(DataPathContext);
    const inca = useContext(IncaContext);
    if (!path && (!tableName || !rowId)) {
        throw new Error('path or (tableName and rowId) must be set.');
    }
    const newPath = useMemo(()=>{
        return path || [
            ...curPath,
            // If:en ett par rader upp garanterar att tableName och rowId är satt om inte path är det.
            {
                tableName: tableName,
                rowId: rowId
            }
        ];
    }, [
        path,
        curPath,
        tableName,
        rowId
    ]);
    const detachedId = props.detachedId !== undefined ? props.detachedId : curDetachedId;
    const dataActions = useDataActions(newPath, detachedId);
    const providerValue = useMemo(()=>{
        return {
            detachedId,
            path: newPath
        };
    }, [
        newPath,
        detachedId
    ]);
    useEffect(()=>{
        if (process.env.NODE_ENV === 'development' && inca?.type === 'form') {
            const globalMetadata = inca.form.metadata;
            const metadataTables = Object.keys(globalMetadata).map((x)=>({
                    ...globalMetadata[x],
                    tableName: x
                }));
            const byTreeLevel = groupBy(metadataTables, 'treeLevel');
            let hasError = false;
            for(let i = 1; i < newPath.length; i++){
                const parent = globalMetadata[newPath[i - 1].tableName];
                const expectedTableName = byTreeLevel[parent.treeLevel + 1].map((x)=>x.tableName);
                const entry = newPath[i];
                if (expectedTableName.indexOf(entry.tableName) === -1) {
                    // eslint-disable-next-line no-console
                    console.warn(`Path entry ${i + 1} (tableName: '${entry.tableName}', rowId: ${entry.rowId}) has table name mismatch. Expected ${expectedTableName.join(', ')} based on the included tables in the designed form.

This is most likely not intended and probably because of incorrect use of IncaRowContext. Incorrect paths will cause components such as Question not to work`);
                    hasError = true;
                }
                if (!entry.rowId) {
                    // eslint-disable-next-line no-console
                    console.warn(`Path entry ${i + 1} (tableName: ${entry.tableName}, rowId: ${entry.rowId}) does not have a value for rowId.

This could be because row.id is passed instead of row.getId().`);
                    hasError = true;
                }
            }
            if (hasError) {
                // eslint-disable-next-line no-console
                console.table(newPath, [
                    'tableName',
                    'rowId'
                ]);
            }
        }
    }, [
        newPath,
        inca
    ]);
    return /*#__PURE__*/ _jsx(DataPathContext.Provider, {
        value: providerValue,
        children: props.children({
            dataActions,
            path: providerValue.path,
            detachedId: detachedId
        })
    });
};
